// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"600ad142ae1c6cb05936f7719165da9b427003b433d77bd1b8cf9983a7f3f3d6","node_modules_react_index_js":"7d7485f470234010ac1ac35604536f8ddc0956bd2335506d15e1168db6893246"}[chunkId] + ".js";
};